import { Controller } from '@hotwired/stimulus'
import Panzoom from '@panzoom/panzoom'

export default class extends Controller {
  static targets = ['container']
  static values = {
    maxScale: { type: Number, default: 4 },
    minScale: { type: Number, default: 1 }
  }

  connect() {
    if (!this.containerTarget) {
      console.error("PanzoomController: containerTarget is not set.")
      return
    }

    this.panzoom = Panzoom(this.containerTarget, {
      maxScale: this.maxScaleValue,
      minScale: this.minScaleValue
    })
  }

  zoomIn() {
    this.panzoom.zoomIn()
  }

  zoomOut() {
    this.panzoom.zoomOut()
  }

  zoomWithWheel(event) {
    this.panzoom.zoomWithWheel(event)
  }
}